module.exports = __webpack_public_path__ + "img/ic_priview.8b25a0e3.svg";